import React, { useEffect, useState, useCallback } from "react";
import ReactPaginate from "react-paginate";
import axios from "../../axios-backend";
import BackButton from "../main/BackButton";
import Columns from "../main/Columns";
import Line from "../main/Line";
import "./css/ViewProducts.css";

const ViewProductsAuth = (props) => {
  const [productsAuth, setProductsAuth] = useState([]);
  const [pageCount, setPageCount] = useState();
  const pageSize = 10;

  const getData = useCallback((offset) => {
    axios
      .get("/products-auth", {
        params: { offset, pageSize },
      })
      .then((p) => {
        console.log("/products-auth API response:", p.data); // <-- Added logging
        setPageCount(p.data.pageCount);
        setProductsAuth(p.data.list);
      });
  }, [pageSize]);

  useEffect(() => {
    getData(0);
  }, [getData]);

  const handlePageClick = (data) => {
    let selected = data.selected;
    let offset = selected * pageSize;
    getData(offset);
  };

  const renderProductsAuth = () => {
    if (productsAuth.length > 0) {
      return productsAuth.map((p, index) => {
        // converting utc to Vancouver time zone and in readable format
        let utcTimestamp = p.transferDateTime;
        let vancouverTime = new Date(utcTimestamp).toLocaleString("en-US", { timeZone: "America/Vancouver" });
        return (
          <Line type="bottom-line" key={index}>
            <Columns width="5%">{index + 1}</Columns>
            <Columns width="5%">{p.pid}</Columns>
            <Columns width="20%">{p.name}</Columns>
            <Columns width="10%">{p.cardNumber}</Columns>
            <Columns width="10%">{p.password}</Columns>
         <Columns width="20%">
              <div
                style={{
                  lineHeight: "1.5",
                  overflow: "visible",
                  minHeight: "42px",
                  display: "flex",
                  alignItems: "center",
                  padding: "4px 6px",
                }}
              >
                {p.email}
              </div>
          </Columns>
            <Columns width="20%">{vancouverTime}</Columns>
          </Line>
        );
      });
    } else {
      return (
        <Line type="bottom-line" style={{ justifyContent: "center" }}>
          No items found on this page.
        </Line>
      );
    }
  };

  return (
    <div style={{ height: "100%" }}>
      <BackButton />
      <Line type="bottom-line">
        <Columns width="5%">Index</Columns>
        <Columns width="5%">ProductId</Columns>
        <Columns width="20%">Name</Columns>
        <Columns width="10%">card number</Columns>
        <Columns width="10%">Password</Columns>
        <Columns width="20%">Email</Columns>
        <Columns width="20%">transferDateTime</Columns>
      </Line>
      {renderProductsAuth()}
      <Line type="bottom-line">
        <div className="paginate-container">
          <ReactPaginate
            previousLabel={"←"}
            nextLabel={"→"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={pageSize}
            onPageChange={handlePageClick}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"bolder-a"}
            disabledClass={"disable-a"}
          />
        </div>
      </Line>
    </div>
  );
};

export default ViewProductsAuth;
